export enum NotFoundCause {
  PAGE = 'page',
  ACCOUNT = 'account',
  SSO_ONLY = 'sso_only',
}
